import { EExtractionStatus, IStudyExtractionStatus } from 'pages/Extraction/Extraction.types';
import { useProjectExtractionStudysetId, useProjectExtractionStudyStatusList } from 'stores/projects/ProjectStore';
import { useEffect, useState } from 'react';
import useGetStudysetNonNestedById from 'hooks/studysets/useGetStudysetNonNestedById';

export interface IExtractionSummary {
    savedForLater: number;
    unreviewed: number;
    completed: number;
    total: number;
}

export const getExtractionSummary = (studysetStudiesArg: Array<string>, studyStatusList: IStudyExtractionStatus[]) => {
    const studysetStudies = studysetStudiesArg || [];

    const summary = {
        total: studysetStudies.length,
        completed: 0,
        savedForLater: 0,
        unreviewed: 0,
    };

    studysetStudies.forEach((studyId) => {
        // this studyStatusList is initially empty. Studies get added to it when they are moved to complete or saveforlater, i.e.
        // when they are categporized. We treat any study not yet in this list as unreviewed.
        const foundStatus = studyStatusList.find((status) => status.id === studyId);

        switch (foundStatus?.status) {
            case EExtractionStatus.COMPLETED:
                summary.completed++;
                break;
            case EExtractionStatus.SAVEDFORLATER:
                summary.savedForLater++;
                break;
            default:
                summary.unreviewed++;
                break;
        }
    });

    return summary;
};

const useGetExtractionSummary = (projectId: string | undefined) => {
    const studysetId = useProjectExtractionStudysetId();
    const studyStatusList = useProjectExtractionStudyStatusList();
    const { data: studyset } = useGetStudysetNonNestedById(studysetId);
    const [extractionSummary, setExtractionSummary] = useState<IExtractionSummary>({
        savedForLater: 0,
        unreviewed: 0,
        completed: 0,
        total: 0,
    });

    useEffect(() => {
        setExtractionSummary((prev) => {
            if (!projectId || !studysetId || !studyStatusList) {
                return {
                    savedForLater: 0,
                    unreviewed: 0,
                    completed: 0,
                    total: 0,
                };
            }

            const studysetStudies = studyset?.studies ?? [];
            return getExtractionSummary(studysetStudies, studyStatusList);
        });
    }, [projectId, studyStatusList, studyset, studysetId]);

    return { ...extractionSummary };
};

export default useGetExtractionSummary;
